<template>
  <a-config-provider
    :theme="{
      algorithm: theme.darkAlgorithm,
    }"
  >
    <div class="dashboard">
      <HeaderComponent />
      <main class="main-content">
        <section class="left-column">
          <div class="item">
            出入园数量统计
            <EnteringAndLeaving
              class="chart"
              ref="enteringAndLeaving"
            ></EnteringAndLeaving>
          </div>
          <div class="item">
            设备
            <Device class="chart" ref="device"></Device>
          </div>
          <div class="item">
            当日预约记录统计
            <DailyReservation
              class="chart"
              ref="dailyReservation"
            ></DailyReservation>
          </div>
        </section>

        <section class="center-column">
          <MainTop></MainTop>
          <Main class="main-chart"></Main>
        </section>

        <section class="right-column">
          <div class="item">
            超时未出园/入园统计
            <ExceedingTimeLimit
              class="chart"
              ref="exceedingTimeLimit"
            ></ExceedingTimeLimit>
          </div>
          <div class="item">
            当日安检报警
            <DeviceAlarm class="chart" ref="deviceAlarm"></DeviceAlarm>
          </div>
          <div class="item">
            预约数量统计
            <Reservation class="chart" ref="reservation"></Reservation>
          </div>
        </section>
      </main>
    </div>
  </a-config-provider>
</template>

<script setup>
  import HeaderComponent from './HeaderComponent.vue'
  import EnteringAndLeaving from './EnteringAndLeaving.vue'
  import Device from './Device.vue'
  import DeviceAlarm from './DeviceAlarm.vue'
  import DailyReservation from './DailyReservation.vue'
  import ExceedingTimeLimit from './ExceedingTimeLimit.vue'
  import Reservation from './Reservation.vue'
  import MainTop from './MainTop.vue'
  import Main from './Main.vue'
  import { theme } from 'ant-design-vue'
  import { ref, onMounted, onUnmounted } from 'vue'

  //图表实时自适应宽高
  const enteringAndLeaving = ref()
  const dailyReservation = ref()
  const exceedingTimeLimit = ref()
  const reservation = ref()
  const device = ref()
  const deviceAlarm = ref()
  const observer = ref()
  onMounted(() => {
    let timer
    observer.value = new ResizeObserver(() => {
      if (!timer)
        timer = setTimeout(() => {
          device?.value?.resize && device.value.resize()
          deviceAlarm?.value?.resize && deviceAlarm.value.resize()
          dailyReservation?.value?.resize && dailyReservation.value.resize()

          exceedingTimeLimit?.value?.chart?.resize &&
            exceedingTimeLimit.value.chart.resize()
          enteringAndLeaving?.value?.chart?.resize &&
            enteringAndLeaving.value.chart.resize()
          reservation?.value?.chart?.resize &&
            reservation.value.chart.resize()
          timer = undefined
        }, 100)
    })
    observer.value.observe(document.querySelector('.dashboard'))
  })
  onUnmounted(
    // () =>
    //   observer.value &&
    //   observer.value.unobserve(document.querySelector('.dashboard'))
  )
</script>

<style lang="less" scoped>
  /deep/ .artistic_font_numbers {
    font-family: 'Oxanium';
  }

  .dashboard {
    height: 100vh;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    background-size: cover;

    color: #ffffffa8;
    background: linear-gradient(135deg, #0a1f44, #0f4c81);
  }

  .main-content {
    display: flex;
    flex: 1;
    gap: 26px;
    padding: 20px;
  }

  .left-column,
  .right-column {
    flex: 1 1 25%;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .center-column {
    flex: 2 1 50%;
    display: flex;
    flex-direction: column;
    gap: 26px;
  }

  .item {
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  .chart,
  .main-chart {
    flex: 1;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
    position: relative;
    overflow: hidden;
  }
</style>
